import { nanoid } from "nanoid";
import { getSessionForAccessInfo } from "./GraphMain";
import { checkArLogTable } from "./graphAppInfoCheckFunctions";
import { formatDateTimeForLog, getIdFromNormalizedElementTypeId } from "../utils/helper";
import { getLocalCellNameFromAddress, getSheetNameFromAddressForUrl } from "../utils/helperExcel";
import { getWorksheetUrlSection } from "./helper";
import store from "./StoreRoot";

const { zonedTimeToUtc } = require('date-fns-tz')
const timeZone = "Europe/Berlin";


async function addNewTableRows(newChanges, fileUrl, sessionId, client) {

  // get the different records
  let newRecords = []
  newChanges.forEach((newChange) => {
    if (newRecords.filter(item => item.rowIndex === newChange.rowIndex).length === 0) {
      newRecords.push({
        rowIndex: newChange.rowIndex,
        rowNumber: -1,
        tableId: newChange.tableId
      })
    }
  })
  if (newRecords.length === 0) return newRecords;

  // get the table details
  const tableName = newRecords[0].tableId.replace("table_", "");
  const tableDetail = await client.api(fileUrl + "/workbook/tables/{"+tableName+"}/headerRowRange")
    .header("workbook-session-id", sessionId)
    .get();
  const columns = tableDetail.text[0];

  // create the records with the new values
  newRecords.forEach((newRecord) => {
    try {
      // get all the chanced cells for this record
      let newValues = newChanges.filter(item => item.rowIndex === newRecord.rowIndex);

      // define the new values
      let newRowValues = [];
      columns.forEach((column) => {
        let obj = newValues.find(o => o.columnName === column);
        const newValue = obj ? obj.newValue : null;

        newRowValues.push(newValue);
      })

      // write the a new row to table with name tableId
      const tableName = newRecord.tableId.replace("table_", "");
      const logRows = {
        values: [newRowValues]
      };
      client.api(fileUrl + "/workbook/tables/{"+tableName+"}/rows/add")
        .header("workbook-session-id", sessionId)
        .post(logRows);
    } catch (err) {
      console.error("newRecord", err);
    }
  })
  
  return newRecords;
}

export async function writeElementValueChanges(
  accessInfo: any,
  sharingInformation: any,
  changesList: any[],
  shareStatus: string,
  messageCallback
) {
  const {client, sessionId, fileUrl} = await getSessionForAccessInfo(accessInfo);
  let successfulUpdates = [];
  let unsuccessfulUpdates = [];

  // check record changes - new
  // we need to add table rows and use the rowIndex for the change addresses
  const newChanges = changesList.filter((item) => item.updateType === "new");

  if (newChanges.length > 0) {
    addNewTableRows(newChanges, fileUrl, sessionId, client);
  }

  // ===============================
  // go through all the changes 
  // and set the new values on cell level
  // ===============================

  for (const change of changesList) {
    const updateType = change.updateType;
    const worksheetId = getIdFromNormalizedElementTypeId(change.worksheetId);
    const cellAddress = getLocalCellNameFromAddress(change.address);
    let cellWorksheet = worksheetId ? worksheetId : getSheetNameFromAddressForUrl(change.address);

    
    const cellChangeUrl = fileUrl + "/workbook/"+getWorksheetUrlSection(cellWorksheet)+"/range(address='"+cellAddress+"')";
    let newValue = change.newValue;
    // const cellType = change.cellType;
    // if (cellType === "date") {
    // }

    const cellChangeWorkbookRange = {"values" : [[newValue]]};

    if (change.changeType === "staging") {
      // staging is only for the log list
      successfulUpdates.push(change);
    } else {
      // perhaps get the actual values and compare

      if (updateType !== "new") {

        // write it to the Excel file
        await client
          .api(cellChangeUrl)
          .header("workbook-session-id", sessionId)
          .update(cellChangeWorkbookRange)
          .then((data) => {
            successfulUpdates.push(change);
            console.log("INFO - sucessfully changed: ", change.address);
            (messageCallback) && messageCallback("sucessfully written " + cellAddress, "success");
          })
          .catch((err) => {
            console.log("ERROR happened during fetching!", err);
            (messageCallback) && messageCallback("error writting " + cellAddress + ": " + err.message, "error");
            unsuccessfulUpdates.push(change);
          });
      }
    }
  }

  // ===============================
  // write the log entries
  // ===============================
  const transactionId = nanoid();
  let changesLog = [];
  // prepare the changes log entries
  successfulUpdates.forEach((change) => {
    const utcDate = zonedTimeToUtc(change.modified, timeZone);
    const entry = [
      formatDateTimeForLog(utcDate), // timestamp
      transactionId,
      store.main.userEmail, // collaborator
      change.address,
      change.oldValue,
      change.newValue,
      change.comment,
      change.elementId,
      change.worksheetId,
      change.changeType, // status
      "no", //check_status
      "", // checked_by
      "", // check_time
    ];
    changesLog.push(entry);
  })
  if (changesLog.length > 0) {
    // LOOK FOR THE AR_LOG table
    let logTableFound = await checkArLogTable(fileUrl, sessionId, client, true);

    if (!logTableFound) {
      console.log("ERROR no log-table - unable to write log entries");
      (messageCallback) && messageCallback("need to create system tables");
    } else {
      // write the changesLog to AR_LOG
      const logRows = {
        index: 0,
        values: changesLog
      };
      await client.api(fileUrl + "/workbook/tables/AR_LOG/rows/add")
        .header("workbook-session-id", sessionId)
        .post(logRows);
    }
  }

  return { 
    successfulUpdates: successfulUpdates, 
    unsuccessfulUpdates: unsuccessfulUpdates
  };
}


